const calculateHooksProps = (context, hookConditions, hooks) =>
  Object.keys(hookConditions).map(key => {
    if (hookConditions[key] && hooks) {
      const propFn = hooks[key];
      if (typeof propFn === 'function') {
        return propFn(context);
      }
    }
    return {};
  }, {});

export const createTrackerDispatch = (Tracker, context, hookConditions, { events, eventHooks }) => {
  return {
    dispatch: action => {
      const { type, payload } = action;
      if (events[type]) {
        const hooks = eventHooks[type];
        const { eventName, eventValue, props = () => {} } = events[type];
        const currentContext = { ...context, ...payload };
        const eventProps = props(currentContext);
        const hooksEventProps = calculateHooksProps(currentContext, hookConditions, hooks).reduce((acc, curr) => {
          acc = { ...acc, ...curr };
          return acc;
        }, {});
        const currentProps = {
          ...eventProps,
          ...hooksEventProps,
        };

        Tracker.track(eventName, eventValue, currentProps);
      }
    },
  };
};

export default {
  createTrackerDispatch,
};

